import * as requests from "../coraWebComponents/utils/requests";
import CoraError from "../coraWebComponents/utils/coraError";

const parseFilenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) return null;

  let matches = /filename="(.*?)"/g.exec(contentDisposition);
  return matches && matches.length > 1 ? matches[1] : null;
};
export const getManual = async () => {
  try {
    let response = null;
    response = await fetch(`${window.config.url}/api/manuals/getManual`, {
      headers: {
        Authorization: requests.getAuthorizationHeader(),
      },
    });

    if (response.status === 200) {
      return {
        blob: await response.blob(),
        fileName: parseFilenameFromContentDisposition(
          response.headers.get("content-disposition")
        ),
      };
    } else {
      const res = await response.json();
      if (res.Code === "401.000" && (await requests.refreshToken())) {
        return await getManual();
      }

      throw new CoraError(res);
    }
  } catch (error) {
    throw error;
  }
};
